import { createTheme } from '@mui/material/styles';

import {
  BreakpointSize,
  DEFAULT_FONT_FAMILY,
} from '@constants/common/ui.constants';

const Theme = createTheme({
  primary: {
    p1: '#E245A5',
    p2: '#FFFFFF',
    p3: '#4D9EDC',
  },
  secondary: {
    s1: '#2d4762',
    s2: '#6d7a87',
    s3: '#91A2AF',
    s4: '#3674A5',
    s5: '#1C2D41',
    s6: '#25394F',
  },
  background: {
    b1: '#111d28',
    b2: '#152231',
    b3: '#122435',
  },
  gradient: {
    g1: 'linear-gradient(180deg, #192737 0%, #0B1925 99.38%)',
    g2: 'linear-gradient(98.73deg, #F6A070 6.66%, #D2688B 35.55%, #6A5AB0 64.45%, #4252B5 93.34%)',
    g3: 'linear-gradient(98.73deg, #F76161 6.66%, #DF4A7B 35.55%, #4930B6 64.45%, #0B23B9 93.34%)',
    g4: 'linear-gradient(90deg, #0D2338 0%, #103558 51.56%, #0D2338 100%)',
    g5: 'linear-gradient(90deg, #152B3E 0%, #0F2331 114.19%)',
    g6: 'linear-gradient(90deg, #EE9476 0%, #D97287 27%, #6859AD 57%, #1C2D41 91%)',
    g7: 'linear-gradient(90deg, #E632F6 0%, #6D13E1 100%)',
  },
  accent: {
    a1: '#0EB873',
    a2: '#FAFF00',
    a3: '#FF30FF',
    a4: '#E9AF19',
    a5: '#3CD6BD',
    a6: '#D93930',
    a7: '#0B8E5A',
    a8: '#5FFA00',
    a9: '#4754B5',
  },
  typography: {
    htmlFontSize: 14,
    fontSize: 16,
    fontFamily: DEFAULT_FONT_FAMILY,
    h1: {
      fontWeight: 700,
      fontSize: 40,
      lineHeight: '48px',
    },
    h2: {
      fontWeight: 700,
      fontSize: 32,
      lineHeight: '40px',
    },
    h3: {
      fontWeight: 700,
      fontSize: 24,
      lineHeight: '32px',
    },
    h4: {
      fontWeight: 700,
      fontSize: 18,
      lineHeight: '24px',
    },
    subtitle1: {
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '24px',
    },
    subtitle2: {
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '20px',
    },
    body1: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
    },
    body2: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '20px',
    },
    overline1: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '20px',
      textDecoration: 'underline',
    },
    caption1: {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
    },
    caption2: {
      fontWeight: 600,
      fontSize: 12,
      lineHeight: '16px',
    },
  },
  breakpoints: {
    values: {
      xs: BreakpointSize.Xs,
      sm: BreakpointSize.Sm,
      md: BreakpointSize.Md,
      lg: BreakpointSize.Lg,
      xl: BreakpointSize.Xl,
    },
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '16px',
    xxl: '100px',
  },
});

export default Theme;
